import { useContext } from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import watermindLogo from "assets/waterminds-logo.png";
import UserContext from "common/Context/UserContext";
import { isPlatformAdminProfile } from "common/Utilities/Role.utils";
import { resetPlatformAdminCustomerSelection } from "common/Utilities/CustomerSelection.utils";
import { headerLogoButtonSx, headerLogoSx, headerLogoWrapSx } from "../TopHeader.style";

const HeaderLogo = ({ alt = "Azuria Water Solutions Inc" }) => {
  const navigate = useNavigate();
  const { userProfile, setHeaderSelectedCustomer } = useContext(UserContext);
  const profile = userProfile?.profile;

  const handleHomeClick = () => {
    resetPlatformAdminCustomerSelection();
    setHeaderSelectedCustomer?.(null);
    if (isPlatformAdminProfile(profile)) {
      window.location.assign("/");
      return;
    }
    navigate("/");
  };

  return (
    <Box sx={headerLogoWrapSx}>
      <Box
        component="button"
        type="button"
        onClick={handleHomeClick}
        aria-label="Go to home"
        sx={headerLogoButtonSx}
      >
        <Box component="img" src={watermindLogo} alt={alt} sx={headerLogoSx} />
      </Box>
    </Box>
  );
};

HeaderLogo.propTypes = {
  alt: PropTypes.string,
};

export default HeaderLogo;
